export default "__VITE_ASSET__CGoGdVEq__"